export const areAllValuesEmpty = (obj: Record<string, any>): boolean => {
  if (Object.keys(obj).length === 0) return true;

  return Object.values(obj).every(
    (value) =>
      value === null ||
      value === undefined ||
      (typeof value === 'string' && value.trim() === '') ||
      (Array.isArray(value) && value.length === 0) ||
      (typeof value === 'object' && value !== null && Object.keys(value).length === 0),
  );
};
